import { render, staticRenderFns } from "./FormatsTable.vue?vue&type=template&id=b7c20b3a"
import script from "./FormatsTable.vue?vue&type=script&lang=js"
export * from "./FormatsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports